import axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import store from '@/store'
// import { getToken,setToken } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import { base_url } from '@/utils/setupConfig'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// import Cookies from "js-cookie";
import {getUser,compileStr,uncompileStr} from "@/utils/tools";
let reqUrlarr=[];
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: base_url,
  // 超时
  timeout: 60000,//一分钟
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
    // alert(getToken());
  // if (getToken() && !isToken) {
  //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // 记录页面请求url  用于判断接口只调用一次
  // reqUrlarr.push(config.url)
  // let login7dayKeyStr= Cookies.get('login7dayKey');
  // // console.log(login7dayKeyStr,' ====  login7dayKeyStr')
  // // 7天内免登录  login7dayKeyStr未过期  并且没登录  调用后自动登录
  // if (!getUser().userId&&login7dayKeyStr!='null'&&reqUrlarr.length==1) {
  //   axios({
  //     method: 'post',
  //     url: base_url+'/login7day',
  //     data: {
  //       login7dayKey:login7dayKeyStr,
  //     }
  //   }).then(res =>{    
  //     if(res.data.code==200){
  //       setToken(res.data.token)
  //       localStorage.setItem('user', compileStr(JSON.stringify(res.data.user)));
  //       window.reload();

  //     }
  //   })
  // }


  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    if (code === 401) {
      // store.commit('login/changeLoginShow', true);
      Message({
        message: '登录状态已过期，请重新登录',
        type: 'warning'
      })
      // location.href = '/home';
      // localStorage.clear();
      // sessionStorage.clear();
      // MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
      //     confirmButtonText: '重新登录',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }
      // ).then(() => {
      //   store.dispatch('LogOut').then(() => {
      //     location.href = '/login';
      //     localStorage.removeItem('user');
      //   })
      // })
    } else if (code === 500) {
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    } else {
      reqUrlarr=[]
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      // message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
